import { render, staticRenderFns } from "./ViewServer.vue?vue&type=template&id=7bada30b&scoped=true"
import script from "./ViewServer.vue?vue&type=script&lang=js"
export * from "./ViewServer.vue?vue&type=script&lang=js"
import style0 from "./ViewServer.vue?vue&type=style&index=0&id=7bada30b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bada30b",
  null
  
)

export default component.exports